/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Metric_Listings_CreatedInputs */

const cs_import_done_metric_listings_created = /** @type {(inputs: Import_Done_Metric_Listings_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti vytvořeny`)
};

const en_import_done_metric_listings_created = /** @type {(inputs: Import_Done_Metric_Listings_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings created`)
};

/**
* | output |
* | --- |
* | "Listings created" |
*
* @param {Import_Done_Metric_Listings_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_metric_listings_created = /** @type {((inputs?: Import_Done_Metric_Listings_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Metric_Listings_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_metric_listings_created(inputs)
	return cs_import_done_metric_listings_created(inputs)
});